import APIService from "./api.service";

class AuthService extends APIService {
  static endpoint = "api";

  static encryptCredentials({ email, password }) {
    return window.btoa(email + ":" + password);
  }

  static async getUserToken({ credentialsEncrypted }) {
    try {
      const response = await APIService.post(`/${this.endpoint}/login`, null, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic " + credentialsEncrypted
        }
      });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async getUserInfoByToken(token) {
    try {
      const response = await APIService.get(
        `/${this.endpoint}/usuario-autenticado`,
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      );
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default AuthService;
